import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IPartialGradeMetricsQuery } from 'app/library/partial-grade/interfaces/partial-grade-metric.query.interface';
import { PartialGradeMetrics } from 'app/library/partial-grade/models/partial-grade-metric.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICreateGradedUnitFromCourseOfferingActionPayload } from '../interfaces/create-graded-unit-from-course-offering.action.payload.interface';
import { IGradedUnitQuery } from '../interfaces/graded-unit.query.interface';
import { GradedUnitUpdateCommand } from '../models/graded-unit-update.command.model';
import { GradedUnitCommand } from '../models/graded-unit.command.model';
import { GradedUnit } from '../models/graded-unit.model';

@Injectable()
export class GradedUnitApiService extends EntityService<IGradedUnitQuery> implements IEntityApiService<GradedUnit> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'graded-units');
    }

    getAll(): Observable<GradedUnit[]> {
        throw new Error('Method not implemented.');
    }

    create(entity: GradedUnit): Observable<GradedUnit> {
        const data = new GradedUnitCommand(entity);

        return this._create(data).pipe(map((query) => new GradedUnit(query)));
    }

    read(id: string): Observable<GradedUnit> {
        return this._read(id).pipe(map((query) => new GradedUnit(query)));
    }

    update(entity: GradedUnit): Observable<GradedUnit> {
        const data = new GradedUnitUpdateCommand(entity);

        return this._update(entity.id, data).pipe(map((query) => new GradedUnit(query)));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }

    metrics(id: string): Observable<PartialGradeMetrics> {
        return this.http.get<IPartialGradeMetricsQuery>(`${this.apiUrl}/${this.entities}/${id}/metrics`).pipe(map((query) => new PartialGradeMetrics(query)));
    }

    createGradedUnitFromCourseOffering(data: ICreateGradedUnitFromCourseOfferingActionPayload): Observable<GradedUnit[]> {
        return this.http
            .post<IGradedUnitQuery[]>(`${this.apiUrl}/${this.entities}/from-course-offering`, data)
            .pipe(map((queries) => queries.map((query) => new GradedUnit(query))));
    }
}
